import React, { FC } from "react";
import { InputSelectProperties, } from "src/framework/components/forms";
import {
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Theme,
} from "@mui/material";

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import "./style.css";
import theme from "src/theme/light";

export interface FormasPagamentos {
  id: number;
  nome: string;
}

export interface InputSelectFormasPagamentosProperties extends InputSelectProperties {
  list: FormasPagamentos[];
  value: number[];
  onChange(value: any): void;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    menuHeader: {
      backgroundColor: theme.palette.background.default,
    },
    chip: {
      margin: 2,
    },
  })
);

const InputSelectFormasPagamentos: FC<InputSelectFormasPagamentosProperties> = (props: InputSelectFormasPagamentosProperties) => {
  const classes = useStyles();

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const { target: { value } } = event;
    const selecteds: number[] =
      typeof value === 'string'
        ? value.split(',').map(Number)
        : value.map(Number);

    if (props.onChange) {
      props.onChange(
        props.list.filter(
          (reg: FormasPagamentos) => selecteds.includes(reg.id)
        )
      );
    }
  };

  return (
    <FormControl
      fullWidth={true}
      variant="outlined"
      size={"small"}
      className={classes.formControl}
    >
      <InputLabel id="select-forma_pagto-label" style={{ backgroundColor: "#fff", padding: "0px 1px" }}>
        {props.label}
      </InputLabel>
      <Select
        style={{ textAlign: "left" }}
        labelId="select-forma_pagto-label"
        id="forma_pagto-mutiple-checkbox"
        multiple
        value={props.value.map(String)}
        onChange={handleChange}
        renderValue={(selected) => {
          const selectedIds = selected.map(Number);

          const selectedFormasPagamentos: FormasPagamentos[] =
            props.list.filter((reg) => selectedIds.includes(reg.id));

          return (
            <div className={classes.chip}>
              {selectedFormasPagamentos.map((tipoContas) => (
                <Chip
                  key={tipoContas.id}
                  label={tipoContas.nome}
                  className={classes.chip}
                  size="small"
                />
              ))}
            </div>
          );
        }}
        MenuProps={MenuProps}>
        {props.list.map((_perfil: FormasPagamentos) => (
          <MenuItem key={_perfil.nome} value={_perfil.id}>
            <Checkbox checked={props.value.indexOf(_perfil.id) > -1} />
            <ListItemText primary={_perfil.nome} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { InputSelectFormasPagamentos };
